import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState, useRef } from "react";
import {NavLink, useNavigate, useParams } from "react-router-dom";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { format, parse } from 'date-fns';
import { FaCalendarAlt } from 'react-icons/fa';
import axios from "axios";

import CustomEditor from "../../../component/CustomEditor"; // Import the centralized CKEditor component

const AddExhibition = () =>{

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const { id } = useParams();
    const navigate = useNavigate();
    const editorRef = useRef(); // Ref to store the CKEditor instance
    const [title, setTitle] = useState("");
    const [newdata, setNewdata] = useState({
        title: '', dateStart: new Date(), dateEnd: new Date(), imageURL: '', exhibitionDetails: ''
    });

    const handleDateChange = (date, name) => {
        setNewdata({ ...newdata, [name]: date });
    };
    
    
    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <div className="input-group">
            <input
                type="text"
                className="form-control"
                value={value}
                onClick={onClick}
                readOnly
                ref={ref}
            />
            <div className="input-group-append">
                <span className="input-group-text" onClick={onClick}>
                    <FaCalendarAlt />
                </span>
            </div>
        </div>
    ));

    const fetchExhibitionStartDate = async () => {
        try {
            const response = await fetch('https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetNextExhibitionStartDate'); // Update with your API URL
            const data = await response.json();
            if (data) {
                // Convert the fetched dateStart to a Date object
                const startDate = new Date(data.dateStart);

                // Add 1 day to startDate
                const endDate = new Date(startDate); // Create a new Date object for endDate                
                endDate.setDate(startDate.getDate() + 1); // Add 1 day

                // Update the newdata state with the fetched date
                setNewdata((prevData) => ({
                    ...prevData,
                    dateStart: data.dateStart, // Update the dateStart field with the fetched date
                    
                    dateEnd: endDate
                }));
            }          

        } catch (error) {
            console.error('Error fetching start date:', error);
        }
    };
    
    useEffect(() => {
        fetchExhibitionStartDate();
    }, []);

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    // Modified useEffect for data fetching
    useEffect(() => {
        if (id) {            
            fetchData('https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionDetailsToEditByID?id=' + id, (data) => {
                const exhibitionData = data;
                if(data){
                setNewdata({
                    title: exhibitionData.exhibitionTitle,
                    dateStart: new Date(exhibitionData.dateStart), // Ensure date is in correct format
                    dateEnd: new Date(exhibitionData.dateEnd),
                    imageURL: exhibitionData.imageURL
                });
                setTitle(exhibitionData.exhibitionTitle); // Also set the title state
                if (editorRef.current) {
                    editorRef.current.setData(exhibitionData.description);
                }
            }
            });
        }
        
    }, [id]);


    const handleTitleChange = (event) => {
        const newTitle = event.target.value;
            setTitle(newTitle);
            setNewdata(prevData => ({
            ...prevData,
            title: newTitle // Update newdata.title whenever the title changes
    }));
    };

    const handleExhibitionDetailsEditorChange = (content) => {        
        setNewdata(prevData => ({
            ...prevData,
            exhibitionDetails: content
        }));
    };


    const handleUpdate = async () => {
        
        // Check if both title and policyDetails are not empty
        if (title.trim() === '' || newdata.exhibitionDetails.trim() === '') {
            alert('Please fill in all fields.'); // You can replace this with a more sophisticated validation message
            return; // Prevent form submission if validation fails

        }
            const formattedStartDate = format(newdata.dateStart, 'yyyy-MM-dd');
            const formattedEndDate = format(newdata.dateEnd, 'yyyy-MM-dd');

        const formData = {
            "id":id,
            "exhibitionTitle": title,
            "description": newdata.exhibitionDetails,
            "dateStart":formattedStartDate,
            "dateEnd":formattedEndDate,
            "createdBy": userInfo.id
        };

        try {
            // Make the API call to save the form data
            const response = await fetch(`https://igapi.heuristticminds.com/api/ExhibitionList/Update-UpdateExhibitionDetails`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {

                setTitle(''); // Clear the title input Box
                // Clear CKEditor content using the API
                if (editorRef.current) {
                    editorRef.current.setData(''); // This clears the editor content
                }
                alert("Exhibition Details Updated Successfully !!!");
                
                navigate(`/exhibition/`);

            } else {
                // Handle error cases
                console.error('Error saving form data:', response.statusText);
            }
        } catch (error) {

            console.error('Error saving form data:', error);
        }

    };


    const handleSubmit = async () => {
    
        // Check if both title and policyDetails are not empty
        if (title.trim() === '' || newdata.exhibitionDetails.trim() === '') {
            alert('Please fill in all fields.'); // You can replace this with a more sophisticated validation message
            return; // Prevent form submission if validation fails
        }
            const formattedStartDate = format(newdata.dateStart, 'yyyy-MM-dd');
            const formattedEndDate = format(newdata.dateEnd, 'yyyy-MM-dd');

        const formData = {

            "exhibitionTitle": title,
            "description": newdata.exhibitionDetails,
            "dateStart":formattedStartDate,
            "dateEnd":formattedEndDate,
            "createdBy": userInfo.user_id
        };
        try {
            
            // Make the API call to save the form data
            const response = await fetch('https://igapi.heuristticminds.com/api/ExhibitionList/Add-SaveExhibitionDetails', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                
                setTitle(''); // Clear the title input Box
                // Clear CKEditor content using the API
                if (editorRef.current) {
                    editorRef.current.setData(''); // This clears the editor content
                }
                alert("Exhibition Details Saved Successfully !!!");
                navigate(`/exhibition/`);
            } else {
                // Handle error cases
                console.error('Error saving form data:', response.statusText);
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }

    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0]; // Get the selected file
        if (!file) {
            console.error('No file selected');
            return;
        }

        // Immediately upload the image after selection
        try {
            await handleExhibitionTitleImageUpload(file);
        } catch (error) {
            console.error('Error during image change:', error);
        }
    };


    const handleExhibitionTitleImageUpload = async(file) =>{
        
        const formData = new FormData();
        formData.append('exhibitionImage', file);
        try {
            debugger;
            const uploadResponse = await axios.post('http://localhost:3000/uploadImage/uploadExhibitionImage', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            
            const uploadedImageName = uploadResponse.data.fileUrl;
            const imageDetails = {
                    imageURL: uploadedImageName,
                    id: id,
                    createdBy: userInfo.user_id
                };
                return axios.post('https://igapi.heuristticminds.com/api/ExhibitionList/Add-SaveExhibitionTitleImage', imageDetails);                   

        } catch (error) {
            console.error('Error uploading files:', error);
        }
    }


    return(
        <>
        <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name= {id > 0 ? "Edit Exhibition Details" : "Add Exhibition Details"}  icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Exhibition Details</div>
                                    <div className="card-body">
                                        <NavLink className="btn btn-primary float-end" to={'/exhibition'}  onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                        <div className="clearfix"></div>
                                        <div className="p-4 pt-2">
                                            {id ? (
                                            <div className="row">
                                                    {/* <div className="col-sm-5">
                                                        <div className="imgpreview">
                                                            <img src={`../images/products/thumbnail/${newdata.image}`} alt="" />
                                                        </div>
                                                    </div> */}
                                                    <div className="col-sm-5">
                                                    <div className="imgpreview">

                                            {/* Label makes the image clickable */}
                                                <label htmlFor="uploadImage" style={{ cursor: 'pointer' }}>
                                                    <img 
                                                        src={newdata.imageURL === "NA" ? "../../images/exhibition/exhibitionImage.jpeg" : `../../images/exhibition/thumbnail/${newdata.imageURL}`}
                                                        alt="Title Image"  
                                                    />
                                                </label>
                                            {/* Hidden file input */}
                                            <input
                                                id="uploadImage"
                                                type="file"
                                                style={{ display: 'none' }}
                                                onChange={handleImageChange}
                                            />  
                                        </div>
                                        </div>
                                                    
                                                </div>
                                            ): null}

                                            <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                    <label>Title <span style={{ color: "#ff0000" }}>*</span></label>
                                                    <input type="text"
                                                        name="title"
                                                        value={title}
                                                        className="form-control"
                                                        maxLength={45}
                                                        placeholder="Title"
                                                        onChange={handleTitleChange} />
                                                </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                        <label>Start Date<span style={{ color: "#ff0000" }}>*</span></label>
                                                        <DatePicker
                                                            selected={newdata.dateStart}
                                                            onChange={(date) => handleDateChange(date, 'dateStart')}
                                                            customInput={<CustomInput value={format(newdata.dateStart, 'dd-MM-yyyy')} />}
                                                            dateFormat="dd-MM-yyyy"
                                                            minDate={newdata.dateStart} // Disable backdating
                                                        />
                                                    </div>
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label>End Date<span style={{ color: "#ff0000" }}>*</span></label>
                                                        <DatePicker
                                                            selected={newdata.dateEnd}
                                                            onChange={(date) => handleDateChange(date, 'dateEnd')}
                                                            customInput={<CustomInput value={format(newdata.dateEnd, 'dd-MM-yyyy')} />}
                                                            dateFormat="dd-MM-yyyy"
                                                            minDate={newdata.dateEnd} // Disable backdating
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-12 form-group mb-3">
                                                    <label>Exhibition Write-up <span style={{ color: "#ff0000" }}>*</span></label>
                                                    
                                                        <CustomEditor 
                                                                ref={editorRef} 
                                                                value={newdata.exhibitionDetails} 
                                                                onChange={handleExhibitionDetailsEditorChange} 
                                                                placeholder="Enter Exhibition Details / Description"
                                                            /> 
                                                </div>
                                            </div>
                                            
                                               
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6 form-group mt-3">
                                                {id>0 ?
                                                            <button type="button" onClick={handleUpdate} className="btn btn-primary w-50">Update</button>
                                                            :
                                                            <button type="submit"
                                                            onClick={handleSubmit}
                                                                className="btn btn-primary w-50">Submit</button>
                                                        }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <Footer />
                </div>
            </div>
        </>
    );
};
export default AddExhibition;